define('views/modules/calendar/personal-data/list/personal-data-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/calendar/personal-data/list/personal-data-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    // templates
    TPersonalDataListItem
) {

    var VPersonalDataListItem = Backbone.View.extend({
        template: TPersonalDataListItem,

        regions: {
            infobox: ".item-section",
        },
        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox(
                    _.extend(
                        this.getMediaInfoBoxOptions(),
                        this.model.isConvertible() ? {
                            customTitle: i18n.t(this.model.get('name')),
                            title: null,
                            customSubtitle: this.model.getTranslatedUnit(),
                            subtitle: null
                        } : {}
                    )
                ),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },
        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones()
                .assign(this.view.infobox, this.regions.infobox);

            return this;
        },

        getMediaInfoBoxOptions: function() {
            return {
                title: 'name',
                subtitle: 'unit',
                tinyinfo: 'description',
                model: this.model,
                context: this,
                onClick: this.onPersonalDataClick,
                menu: {
                    init: this.onMenuInit,
                    onClick: this.onActionClick,
                }
            };
        },

        deletePersonalData: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    // FIXME add error notification when personal-data deletion failed
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });

        },

        ////////////
        // events //
        ////////////

        onPersonalDataClick: function() {
            this.model.trigger('personalData:click', this.model);
        },

        onMenuInit: function() {
            return new Backbone.Collection([
                { caption: 'Edit', icon: "sl-icon-pencil", callback: this.onEditAction },
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onDeleteAction: function() {
            if (this.model.get('global')) {
                Bootbox.alert({
                    title: i18n.t('you-cannot-delete-or-edit-a-global-custom-data-def-title'),
                    message: i18n.t('you-cannot-delete-or-edit-a-global-custom-data-def-content'),
                    onEscape: true,
                    backdrop: true,
                    context: this,
                });
                return;
            }

            Bootbox.confirm({
                title: i18n.t("calendar:Delete personal data"),
                message: i18n.t("messages:message-delete-personal-data"),
                onEscape: true,
                backdrop: true,
                callback: this.deletePersonalData,
                context: this,
            });
        },

        onEditAction: function() {
            this.model.trigger('personalData:click', this.model);
        }

    });

    return VPersonalDataListItem;

});

